import React from "react";

export const Badge = ({ badgeContent = 0, children, className = "", onClick }) => {
  const Component = onClick ? "button" : "span";
  const componentProps = onClick ? { type: "button", onClick } : {};

  return (
    <Component className={`relative inline-flex items-center justify-center ${className}`} {...componentProps}>
      {children}
      {Number(badgeContent) > 0 && (
        <span className="absolute -right-2 -top-2 inline-flex min-h-5 min-w-5 items-center justify-center rounded-full bg-blue-600 px-1.5 text-xs font-semibold leading-none text-white">
          {badgeContent}
        </span>
      )}
    </Component>
  );
};

export const Menu = ({ children, open }) => {
  if (!open) return null;

  return (
    <div
      className="absolute right-0 top-full z-50 mt-2 min-w-44 overflow-hidden rounded-md border border-slate-200 bg-white py-1 shadow-lg"
      role="menu"
    >
      {children}
    </div>
  );
};

export const MenuItem = ({ children, onClick }) => (
  <button
    className="flex w-full items-center px-4 py-2 text-left text-sm text-slate-700 transition hover:bg-slate-50"
    onClick={onClick}
    role="menuitem"
    type="button"
  >
    {children}
  </button>
);
